import { render, staticRenderFns } from "./MarkFileJoin.vue?vue&type=template&id=054551a6&scoped=true&"
import script from "./MarkFileJoin.vue?vue&type=script&lang=js&"
export * from "./MarkFileJoin.vue?vue&type=script&lang=js&"
import style0 from "./MarkFileJoin.vue?vue&type=style&index=0&id=054551a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054551a6",
  null
  
)

export default component.exports